import { useParams, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Nav } from "../components/site/Nav";
import { CityHero } from "../components/site/CityHero";
import { CityLocal } from "../components/site/CityLocal";
import { Threat } from "../components/site/Threat";
import { Process } from "../components/site/Process";
import { WhyUs } from "../components/site/WhyUs";
import { Plans } from "../components/site/Plans";
import { Testimonials } from "../components/site/Testimonials";
import { Footer } from "../components/site/Footer";
import { MobileCallBar } from "../components/site/MobileCallBar";
import { FloatingCallButton } from "../components/site/FloatingCallButton";
import { useSeo } from "../components/site/useSeo";
import { findCity } from "../data/cities";
import { SITE } from "../data/site";

const SITE_ORIGIN = "https://atctermiteservices.com";

export default function CityPage() {
  const { slug } = useParams();
  const city = findCity(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const title = city
    ? `Termite Control in ${city.city}, ${city.stateCode} | 35+ Years, Zero Retreats | ATC Pest Control`
    : "Service Area | ATC Pest Control";

  const description = city
    ? `Family-owned termite experts serving ${city.city}, ${city.stateCode} since 1991. 35+ years without a single retreat. Fast scheduling. Call ${SITE.phoneDisplay}.`
    : "";

  const canonical = city ? `${SITE_ORIGIN}/service-areas/${city.slug}` : SITE_ORIGIN;

  const jsonLd = city
    ? {
        "@context": "https://schema.org",
        "@type": ["LocalBusiness", "PestControlService"],
        name: `ATC Pest Control — ${city.city}, ${city.stateCode}`,
        image: `${SITE_ORIGIN}/generated/hero_home.jpg`,
        telephone: "+1-717-356-0740",
        email: SITE.email,
        url: canonical,
        priceRange: "$$",
        description,
        foundingDate: "1991",
        address: {
          "@type": "PostalAddress",
          streetAddress: "4131 Huffmanville Road",
          addressLocality: "Glen Rock",
          addressRegion: "PA",
          postalCode: "17327",
          addressCountry: "US",
        },
        areaServed: {
          "@type": "City",
          name: `${city.city}, ${city.stateCode}`,
          geo: {
            "@type": "GeoCoordinates",
            latitude: city.lat,
            longitude: city.lng,
          },
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.8",
          reviewCount: "148",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
            opens: "07:00",
            closes: "19:00",
          },
        ],
      }
    : null;

  useSeo({ title, description, canonical, jsonLd });

  if (!city) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="App" data-testid={`city-page-${city.slug}`}>
      <Nav />
      <main>
        <CityHero city={city} />
        <CityLocal city={city} />
        <Threat />
        <Process />
        <WhyUs />
        <Plans />
        <Testimonials />
      </main>
      <Footer />
      <MobileCallBar />
      <FloatingCallButton />
    </div>
  );
}
